import React from 'react';

import { useCompletedDateTree } from '../../hooks/use-completed-date-tree';
import { GroupedListProps } from '../../types';
import { MultipleDeadlinesGroupTaskList } from '../deadline-grouping-tasks-list/multiple-deadlines-group-task-list';

export const CompletedDateGroupingTasksList: React.FC<GroupedListProps> = ({
  tasks,
  sortingMode,
  onReorder,
  customOrder = {},
  collapsedSections = [],
  onSectionCollapse,
  weekStartsOn,
  scrollElement,
  denseFormat,
  groupSettings,
  isContextMenuOpen,
  defaultNewTaskDate,
}) => {
  const treeData = useCompletedDateTree({
    tasks,
    customOrder,
    sortingMode,
    fromDate: groupSettings.completedFromDate,
  });

  return (
    <MultipleDeadlinesGroupTaskList
      treeData={treeData}
      tasks={tasks}
      onReorder={onReorder}
      weekStartsOn={weekStartsOn}
      collapsedSections={collapsedSections}
      onSectionCollapse={onSectionCollapse}
      scrollElement={scrollElement}
      denseFormat={denseFormat}
      isContextMenuOpen={isContextMenuOpen}
      defaultNewTaskDate={defaultNewTaskDate}
      goalId={groupSettings.goalId}
      lifeAreaId={groupSettings.lifeAreaId}
      displayDue={groupSettings.displayDue}
      showRepeatingAsTodo={groupSettings.showRepeatingAsTodo}
    />
  );
};
